export default {"src":"/_next/static/media/stats-preview-bg.63769b33.svg","height":278,"width":1006};